import {Box, CircularProgress} from "@mui/material";

export default function () {
    return  <Box sx={{display: 'flex', mt: 5, mb: 5, width: '100%', justifyContent: 'center', minWidth: 200, minHeight: 200}}>
        <CircularProgress/>
    </Box>
}
